import React, { ReactNode } from "react";
import "./ChatBalloon.scss";

interface IProps {
    type: 'received' | 'sent'
    children: string | ReactNode
    largeMessage?: boolean
}

export function ChatBalloon({type, children, largeMessage = false}: IProps) {
    return (
        <div className={`chat-balloon-wrapper ${type} ${largeMessage ? 'large-message' : ''}`}>
            {children}
        </div>
    )
}
